import parse, { domToReact, HTMLReactParserOptions } from 'html-react-parser';
import { Button } from './Button';
import { ImgLazyLoader, LazyImg } from './ImgLazyLoader';
import { useEffect, useRef } from 'react';
import { YoutubeLazyLoader } from './YoutubeLazyLoader';



const GhostPostSingleScriptWrapper = ({ attribs }: React.PropsWithChildren<{attribs: string[]}>): JSX.Element => {
  const scriptContainerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = document.createElement('script');
    Object.assign(el, attribs);
    scriptContainerRef.current?.appendChild(el);
  }, []);
  return <div ref={scriptContainerRef}></div>;
};

export const convertGhostHTMLToReactComponents = (html: string): string | JSX.Element | JSX.Element[] => {

  // Convert html to React JSX and
  // Parse Ghost post url's and add internal routing Link's
  
  // These are incorrectly picked up by eslint as unmodified.
  // This is because they are set only once, after options is declared
  // However, options needs a reference to these variables before they are set.
  // Frankly this is a silly way of doing this but fuck it I'm not
  // reworking it.

  // eslint-disable-next-line prefer-const
  let mainOptions: HTMLReactParserOptions;
  // eslint-disable-next-line prefer-const
  let noImgOptions: HTMLReactParserOptions;

  const options: (processimg?: boolean) => HTMLReactParserOptions = (processimg = true) => ({
    replace: (node) => {
      const { name, attribs, children, parent } = node as any;
      if(name === 'a' && attribs.href) {
        let link: URL | string = '';
        try {
          link = new URL(attribs.href);
          if(link.hostname === 'www.rockislandauction.com') {
            link = link.pathname;
            return <Button to={link} variant='link' className='p-0'>{domToReact(children, mainOptions)}</Button>;
          }
          else if(parent.attribs.class === 'kg-callout-text') {
            return <Button to={attribs.href}>{domToReact(children, mainOptions)}</Button>;
          }
          else
          {
            return <Button to={attribs.href} variant='link' className='p-0'>{domToReact(children, mainOptions)}</Button>;
          }
        } catch (e) {
          return;
        }
      }
      if(name === 'html') {
        return <>{domToReact(children, mainOptions)}</>;
      }
      if(name === 'head') {
        return <>{domToReact(children, mainOptions)}</>;
      }
      if(name === 'body') {
        return <>{domToReact(children, mainOptions)}</>;
      }
      if(name == 'picture') {
        return <div className='grid w-full aspect-video bg-white/5'>
          <picture className='w-full m-auto'>
            <ImgLazyLoader>{domToReact(children, noImgOptions)}</ImgLazyLoader>
          </picture>
        </div>;
      }
      if(name == 'script') {
        return <GhostPostSingleScriptWrapper attribs={attribs}/>;
      }
      if(processimg) {
        if(name == 'img')
        {
          if(attribs.class)
          {
            if(attribs.class)
            {
              attribs.className = attribs.class;
              delete attribs.class;
            }
            return <LazyImg {... attribs}/>;
          }
        }
        if( name == 'iframe' && attribs.src.indexOf('youtube') !== (-1))
        {
          attribs.width = '100%';
          attribs.height = '100%';
          attribs.className='aspect-video'
          return <div className='overflow-hidden'><YoutubeLazyLoader { ...attribs }/></div>;
        }
      }
      else
      {
        if(name == 'img')
        {
          if(attribs.loading)
          {
            delete attribs.loading;
            return node;
          }
        }
      }
    },
  });
  mainOptions = options();
  noImgOptions = options(false);

  return parse(html, mainOptions);
}